<div class="card completeness-status-card" [class.is-incomplete]="!isComplete()">
  <div class="card-body">
    <div class="status-header">
      <div class="status-copy">
          @let titleTranslationKeyVariable = titleTranslationKey();
        @if(titleTranslationKeyVariable || titleText()) {
            <h3 class="status-title mb-0">
                @if (titleTranslationKeyVariable) {
                <span *transloco="let t; scope: titleTranslationScope()">{{ t(titleTranslationKeyVariable) }}</span>
                } @else {
                <span>{{ titleText() }}</span>
                }
            </h3>
        }
        @let descriptionTranslationKeyVariable = descriptionTranslationKey();
        @if(descriptionTranslationKeyVariable || descriptionText()) {
            <p class="status-description mb-0">
                @if (descriptionTranslationKeyVariable) {
                <span *transloco="let t; scope: descriptionTranslationScope()">{{ t(descriptionTranslationKeyVariable) }}</span>
                } @else {
                <span>{{ descriptionText() }}</span>
                }
            </p>
        }
      </div>

      <span class="status-badge" [class.complete]="isComplete()" [class.incomplete]="!isComplete()">
        @let completeBadgeTranslationKeyVariable = completeBadgeTranslationKey();
        @let incompleteBadgeTranslationKeyVariable = incompleteBadgeTranslationKey();
        @let completeBadgeTextVariable = completeBadgeText();
        @let incompleteBadgeTextVariable = incompleteBadgeText();
        @if (isComplete() ) {
          @if (completeBadgeTextVariable) {
            {{ completeBadgeTextVariable }}
          } @else {
            <span *transloco="let t; scope: completeBadgeTranslationScope()">{{ t(completeBadgeTranslationKeyVariable) }}</span>
          }
        } @else {
          @if (incompleteBadgeTextVariable) {
            {{ incompleteBadgeTextVariable }}
          } @else {
            <span *transloco="let t; scope: incompleteBadgeTranslationScope()">{{ t(incompleteBadgeTranslationKeyVariable) }}</span>
          }
        }
      </span>
    </div>

    <div class="status-requirements mt-3">
      @for (requirement of requirements(); track requirement.id) {
        <p class="requirement mb-2" [class.met]="requirement.met">
          <span [class.d-none]="!requirement.met" aria-hidden="true">
            @if (requirement.metIconClass) {
              <i class="{{ requirement.metIconClass }}"></i>
            } @else {
              <i class="fa-solid fa-check-circle"></i>
            }
          </span>
          <span [class.d-none]="requirement.met" aria-hidden="true">
            @if (requirement.unmetIconClass) {
              <i class="{{ requirement.unmetIconClass }}"></i>
            } @else {
              <i class="fa-regular fa-circle"></i>
            }
          </span>
          @if (requirement.text) {
            {{ requirement.text }}
          } @else {
            <span *transloco="let t; scope: requirement.translationScope">{{ t(requirement.translationKey) }}</span>
          }
        </p>
      }
    </div>
  </div>
</div>
